<template>
    <div class="row g-0">
        <div class="col-lg-3 col-12" style="display: flex;flex-direction: column;">
            <div v-if="inverter_model != null ">
                <div>
                    <button class="point_btn" @click="equip_point_type = 'kwh_today'" :class="{active: equip_point_type == 'kwh_today'}" >本日發電量：{{equip_point_info["kwh_today"]}}<span class="ms-2">kWh</span></button>
                    <button class="point_btn" @click="equip_point_type = 'kwh'" :class="{active: equip_point_type == 'kwh'}" >累計發電量：{{equip_point_info["kwh"]}}<span class="ms-2">kWh</span></button>
                    <button class="point_btn" @click="equip_point_type = 'p_cell_total'" :class="{active: equip_point_type == 'p_cell_total'}" >直流功率：{{equip_point_info["p_cell_total"]}}<span class="ms-2">W</span></button>
<!--                     <button class="point_btn" @click="equip_point_type = 'p_bus_total'" :class="{active: equip_point_type == 'p_bus_total'}" >交流功率：{{equip_point_info["p_bus_total"]}}<span class="ms-2">kW</span></button> -->
                    <button class="point_btn" @click="equip_point_type = 'PR'" :class="{active: equip_point_type == 'PR'}" >PR：{{equip_point_info["PR"]}}<span class="ms-2"></span></button>
                    <button class="point_btn" @click="equip_point_type = 'RA'" :class="{active: equip_point_type == 'RA'}" >RA：{{equip_point_info["RA"]}}<span class="ms-2"></span></button>

                    <div class="point_btn" style="background-color: rgb(176, 176, 176) !important">直流輸入側1</div>
                    <button class="point_btn" @click="equip_point_type = 'v_cell_1'" :class="{active: equip_point_type == 'v_cell_1'}" >直流電壓：{{equip_point_info["v_cell_1"]}}<span class="ms-2">V</span></button>
                    <button class="point_btn" @click="equip_point_type = 'i_cell_1'" :class="{active: equip_point_type == 'i_cell_1'}" >直流電流：{{equip_point_info["i_cell_1"]}}<span class="ms-2">A</span></button>

                    <div class="point_btn" style="background-color: rgb(176, 176, 176) !important">直流輸入側2</div>
                    <button class="point_btn" @click="equip_point_type = 'v_cell_2'" :class="{active: equip_point_type == 'v_cell_2'}" >直流電壓：{{equip_point_info["v_cell_2"]}}<span class="ms-2">V</span></button>
                    <button class="point_btn" @click="equip_point_type = 'i_cell_2'" :class="{active: equip_point_type == 'i_cell_2'}" >直流電流：{{equip_point_info["i_cell_2"]}}<span class="ms-2">A</span></button>
                    
                    <div class="point_btn" style="background-color: rgb(176, 176, 176) !important">交流輸出側L1</div>
                    <button class="point_btn" @click="equip_point_type = 'v_bus_1'" :class="{active: equip_point_type == 'v_bus_1'}" >交流電壓1：{{equip_point_info["v_bus_1"]}}<span class="ms-2">V</span></button>
                    <button class="point_btn" @click="equip_point_type = 'i_bus_1'" :class="{active: equip_point_type == 'i_bus_1'}" >交流電流1：{{equip_point_info["i_bus_1"]}}<span class="ms-2">A</span></button>
                    <button class="point_btn" @click="equip_point_type = 'f_bus_1'" :class="{active: equip_point_type == 'f_bus_1'}" >交流頻率1：{{equip_point_info["f_bus_1"]}}<span class="ms-2">Hz</span></button>
                    
                    <div class="point_btn" style="background-color: rgb(176, 176, 176) !important">交流輸出側L2</div>
                    <button class="point_btn" @click="equip_point_type = 'v_bus_2'" :class="{active: equip_point_type == 'v_bus_2'}" >交流電壓2：{{equip_point_info["v_bus_2"]}}<span class="ms-2">V</span></button>
                    <button class="point_btn" @click="equip_point_type = 'i_bus_2'" :class="{active: equip_point_type == 'i_bus_2'}" >交流電流2：{{equip_point_info["i_bus_2"]}}<span class="ms-2">A</span></button>
                    <button class="point_btn" @click="equip_point_type = 'f_bus_2'" :class="{active: equip_point_type == 'f_bus_2'}" >交流頻率2：{{equip_point_info["f_bus_2"]}}<span class="ms-2">Hz</span></button>
                
                    <div class="point_btn" style="background-color: rgb(176, 176, 176) !important">交流輸出側L3</div> 
                    <button class="point_btn" @click="equip_point_type = 'v_bus_3'" :class="{active: equip_point_type == 'v_bus_3'}" >交流電壓3：{{equip_point_info["v_bus_3"]}}<span class="ms-2">V</span></button>
                    <button class="point_btn" @click="equip_point_type = 'i_bus_3'" :class="{active: equip_point_type == 'i_bus_3'}" >交流電流3：{{equip_point_info["i_bus_3"]}}<span class="ms-2">A</span></button>
                    <button class="point_btn" @click="equip_point_type = 'f_bus_3'" :class="{active: equip_point_type == 'f_bus_3'}" >交流頻率3：{{equip_point_info["f_bus_3"]}}<span class="ms-2">Hz</span></button>

                </div>
            </div>    
            <div class="point_btn_remain"></div>
        </div>
        <plot-zone v-if="equip_point_type !== null" v-bind:ID="inverter_ID" 
        v-bind:datatype="equip_point_type == 'kwh_today'?'kwh':equip_point_type" 
        v-bind:collection="'inverter'" v-bind:key="equip_point_type"></plot-zone>

    </div>
    
    
</template>

<script>
import PlotZone from "./PlotZone.vue"

export default {
    name: "inv_select_zone", 
    props: ["inv_select", "inv_model"],
    components:{
        PlotZone
    },
    data(){
        return{
            inverter_model: this.$props.inv_model,
            inverter_ID: this.$props.inv_select,
            equip_point_type: "kwh_today",
            equip_point_info: {}
        }
    },
    methods:{
        pv_inv_data(){
            console.log(this.inverter_ID)
            const that = this
            this.axios.get(`/pv_inv_data?inv_ID=${this.inverter_ID}`)
            .then(function (data) {
                // 帶入params
                that.equip_point_info = data.data.data
            })
        }
    },
    mounted(){
        console.log(this.$props.inv_select)
        console.log(this.$props.inv_model)
        this.syncdata = setInterval(this.pv_inv_data, 5000)
        this.pv_inv_data()
    },
    destroyed(){
        clearInterval(this.syncdata)
    }
}
</script>
<style src="../../assets/css/PlantInfo.css"></style>